import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getAnotherExperienceByApplicationId(
  applicationId: string
) {
  return await prisma.applicantAnotherExperience.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
